/**
 * Represents a tool that utilizes an iframe.
 * This class initializes with an entry object containing properties like description, iframeTool, and icon.
 */
import RepositoryEntry from './RepositoryEntry';

class IframeTool extends RepositoryEntry {
    /**
     * Constructs an instance of IframeTool.
     */
    constructor(entry, $injector) {
        super(entry, $injector);
    
        this.accessables({
            'description'  : String,
        });

        this.references({
            'iframeTool' : '*',
            'icon': '*'
        });
    }
}

export default IframeTool;